import { equals } from "ramda";
import { useQuery } from "react-query";
import { ParentButton, PrimaryButton, Flex } from "@base-ui";
import { default as StyledImage } from "@cms/components/ui/Image";
import { GridHolder } from "./styles";
import { searchPublicMedia, useCloudfrontContext } from "@media";
import { closePopup } from "utils/events";
import { useAuthContext } from "@authentication/context";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function ImageLibrary(props) {
  var selectImage = props.selectImage,
    height = props.height;
  var _useCloudfrontContext = useCloudfrontContext(),
    baseUrl = _useCloudfrontContext.cloudfrontBaseUrl;
  var _useAuthContext = useAuthContext(),
    getUser = _useAuthContext.getUser;
  var authTicket = getUser().ticket;
  var _useQuery = useQuery(["imagelibrary", authTicket], function () {
      return searchPublicMedia({}, authTicket);
    }, {
      initialData: []
    }),
    publicImages = _useQuery.data;

  //TODO -update url to src
  var imagesMarkup = publicImages.map(function (x, idx) {
    var src = x.url && !equals("media/managed/", x.url) ? x.url : "";
    return /*#__PURE__*/_jsx(ParentButton, {
      "aria-label": "V\xE4lj bild",
      height: "".concat(height, "px"),
      onClick: function onClick() {
        return selectImage({
          alt: x.alt,
          src: x.url
        });
      },
      children: /*#__PURE__*/_jsx(StyledImage, {
        id: x.url,
        src: src && baseUrl && "".concat(baseUrl, "/").concat(src, "_250") || "",
        alt: x.alt || "default"
      })
    }, src || idx);
  });
  return /*#__PURE__*/_jsxs(Flex.Column, {
    id: "select-from-library-panel",
    mt: "10px",
    height: "calc(100% - 54px)",
    flex: "1",
    children: [/*#__PURE__*/_jsx(GridHolder, {
      children: imagesMarkup
    }), /*#__PURE__*/_jsx(Flex.Row, {
      justifyContent: "flex-end",
      children: /*#__PURE__*/_jsx(PrimaryButton, {
        id: "cancel-select-image",
        width: "130px",
        onClick: closePopup,
        children: "Avbryt"
      })
    })]
  });
}